export default __webpack_public_path__ + "static/media/HDTX_Keterbukaan Informasi Perubahan Kegiatan Usaha 2025.5780d322.pdf";